import { Component, OnInit,Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {MatRadioModule,MatSnackBar} from '@angular/material';
import { ToastService } from '../../shared/services/toast.service'
@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.css']
})
export class ApprovalComponent implements OnInit {
  // variables
  public group;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ApprovalComponent>,
    public toastService: ToastService,
  ) { 
    this.group=Object.assign({}, this.data.group)
  }

  ngOnInit() {
  }
  cancel() {
    this.data.group.approval = 'pending';
    this.dialogRef.close();
  }
  proceed() {
    if (this.group.approval === 'Approved' || this.group.approval === 'Disapproved') {
      this.data.group.hrComments = this.group.hrComments;
      this.data.group.approval = this.group.approval;
      this.toastService.success();
    }
    this.dialogRef.close();
  }

}
